export default {
  init() {
    // JavaScript to be fired on all pages
    console.log("Ready player ONE!");

    // wp accessiblity
    jQuery(".pojo-a11y-toolbar-toggle").remove();
    jQuery(".btn-accessibility").on("click", function () {
      jQuery("#pojo-a11y-toolbar").toggleClass("pojo-a11y-toolbar-open");
      console.log("accessiblity open");
    });

    //mover el dropdown CONTACTO hacia la izquierda
    jQuery(function () {
      if (window.innerWidth > 992) {
        jQuery("a:contains('Contacto')")
          .next(".dropdown-menu")
          .attr("style", "margin-left: -120px");
      }
    });
    setTimeout(function () {
      $("#loading").fadeOut(function () {
        $(this).remove();
      });
    }, 500);

    jQuery('[data-toggle="lightbox"]').on("click", function (e) {
      e.preventDefault();
      $(this).ekkoLightbox();
    });

    if (jQuery('body').hasClass('single-anuncio')) {
      jQuery('#sidebar-menu ul li.page-item-33324').addClass('current_page_item');
    }
    if (jQuery('body').hasClass('single-evento')) {
      jQuery('#sidebar-menu ul li.page-item-33320').addClass('current_page_item');
    }
    if (jQuery('body').hasClass('single-noticias')) {
      jQuery('#sidebar-menu ul li.page-item-33321').addClass('current_page_item');
    }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js